module.exports = __webpack_public_path__ + "static/media/arrow-down.d9b571f4.svg";